import {ContactSummaryDto} from "../../../client/contact/ContactApiClient";
import Dialog from "../../../components/dialog/Dialog";
import DialogTitle from "../../../components/dialog/DialogTitle";
import DialogContent from "../../../components/dialog/DialogContent";
import DialogActions from "../../../components/dialog/DialogActions";
import ButtonBar from "../../../components/button/ButtonBar";
import {CancelButton, SelectButton} from "../../../common/button/CommonButtons";
import ContactSearchPanel from "./ContactSearchPanel";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {ContactTranslKey} from "../ContactTranslKey";


export interface ContactSearchDialogProps {
    open: boolean;
    onClose: (selectedContact?: ContactSummaryDto) => void;
}

export default function ContactSearchDialog(props: Readonly<ContactSearchDialogProps>) {
    const {open, onClose} = props;

    const [selected, setSelected] = useState<ContactSummaryDto>();

    const {t} = useTranslation();

    return (
        <Dialog open={open} onClose={() => onClose(undefined)} maxWidth={"lg"}>
            <DialogTitle title={t(ContactTranslKey.SEARCH_CONTACT)} onClose={() => onClose(undefined)} />
            <DialogContent>
                <ContactSearchPanel onSelected={setSelected} />
            </DialogContent>
            <DialogActions>
                <ButtonBar>
                    <CancelButton onClick={() => onClose(undefined)} />
                    <SelectButton variant={"primary"}
                                  disabled={selected === undefined}
                                  onClick={() => onClose(selected)} />
                </ButtonBar>
            </DialogActions>
        </Dialog>
    );
}
